import 'angular:locale/data:fr-FR';(globalThis.$localize ??= {}).locale = "fr-FR";
